/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.19.0
 */

import { useEffect, useState } from 'react';

import isArray from 'lodash/isArray';
import mapValues from 'lodash/mapValues';
import { useLocation } from 'react-router-dom';

import { utoa } from '@/main/sagas/filterToJson';
import { TableFilterPresetQueryId } from '@components/Table/types/tableTypes';

import { ITableInitialise } from '../types';

export const useTableInitialise = (config: ITableInitialise) => {
    const location = useLocation();

    const [updatedConfig, setConfig] = useState<ITableInitialise | null>(null);

    useEffect(() => {
        if (!config) return;

        const query = new URLSearchParams(location.search);
        const queryStringFilter = query.get('f') || '';
        const queryStringSort = query.get('s') || '';

        const filterId = new URLSearchParams(location.search).get(TableFilterPresetQueryId);

        let sort;
        let filter;

        try {
            if (queryStringSort) {
                sort = JSON.parse(decodeURIComponent(queryStringSort));
            }
            if (queryStringFilter) {
                filter = mapValues(JSON.parse(decodeURIComponent(queryStringFilter)), (field, fieldName) => {
                    // TODO: поправить API для меток, отправлять также в value, вместо include
                    if (isArray(field) && fieldName === 'labels') {
                        return { include: field.map((option) => option?.value.toString()) };
                    } else if (isArray(field)) {
                        // Если multiSelect
                        return { value: field.map((option) => utoa(option?.label.toString())) };
                    }
                    return field;
                });
            }
        } catch (err) {
            console.error(err);
        }

        setConfig({
            ...config,
            preset: { filterId, sort, filter },
        });
    }, [location]);

    return {
        updatedConfig,
    };
};
